import { render } from "./PatentDetail.vue?vue&type=template&id=6d2bddc8&scoped=true"
import script from "./PatentDetail.vue?vue&type=script&lang=js"
export * from "./PatentDetail.vue?vue&type=script&lang=js"

import "./PatentDetail.vue?vue&type=style&index=0&id=6d2bddc8&scoped=true&lang=css"

import exportComponent from "C:\\Users\\dursu\\Desktop\\projebaum\\güncelbaumind-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d2bddc8"]])

export default __exports__